module.exports = __webpack_public_path__ + "static/img/tpmbanner.384a0b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tpmbanner.jpg
// module id = gJ8B
// module chunks = 1